import { required } from '@validations'

export default {
  props: {
    pendingReSendOtp: {
      type: Boolean,
      default: false,
    },
    pendingOtp: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    deadline: {
      type: String,
      default: '',
    },
    remainedTime: {
      type: Number,
      default: 0,
    },
    twoFactorTypeLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      verifyCode: '',
      reSendBtn: false,
      isVisible: this.value,
      required,

    }
  },
  watch: {
    value(newVal) {
      this.isVisible = newVal
      if (!newVal) {
        this.resetForm()
      }
    },
    isVisible(newVal) {
      this.$emit('input', newVal)
    },
  },
  methods: {
    async handleOTP() {
      const success = await this.$refs.verifyForm.validate()
      if (success) {
        this.$emit('otp-verified', this.verifyCode)
      }
    },

    async resendOTP() {
      await this.$refs.verifyForm.reset()
      this.$emit('resend-otp')
    },

    timeElapsedHandler() {
      this.reSendBtn = true
    },

    resetForm() {
      this.verifyCode = ''
      this.reSendBtn = false
      if (this.$refs.verifyForm) {
        this.$refs.verifyForm.reset()
      }
    },

    onModalHidden() {
      this.resetForm()
    },
  },
}
